import { useMemo } from 'react';
import { useAppContext } from 'src/contexts/AppContext';

export const useAccessibleMarketplaces = () => {
  const { loginContext } = useAppContext();

  return useMemo(() => {
    const allOfficeMarketplaces = loginContext?.user?.activeAccount
      ?.officeMarketplaceSettings.length
      ? [
          ...new Set(
            loginContext?.user?.activeAccount?.officeMarketplaceSettings
              ?.map((m) => m.mkp)
              .filter((mkp) => mkp != null)
          ),
        ]
      : null;

    return (
      allOfficeMarketplaces ??
      loginContext?.user?.activeAccount?.marketplaceSettings?.map((m) => m.mkp)
    );
  }, [
    loginContext?.user?.activeAccount?.marketplaceSettings,
    loginContext?.user?.activeAccount?.officeMarketplaceSettings,
  ]);
};
